var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import LineWithRoundedCaps from '@marketing/profile/common/LineWithRoundedCaps';
import { clsx } from 'clsx';
import { useEffect, useRef, useState } from 'react';
import { DebounceInput } from 'react-debounce-input';
import { Asterisk } from '../../Icons/Icons';
function FormInputRegular(_a) {
    var className = _a.className, id = _a.id, label = _a.label, maxLength = _a.maxLength, minLength = _a.minLength, onInputChange = _a.onInputChange, pattern = _a.pattern, validate = _a.validate, valueFromProps = _a.value, _b = _a.autoComplete, autoComplete = _b === void 0 ? 'off' : _b, _c = _a.debounceTimeout, debounceTimeout = _c === void 0 ? 300 : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.required, required = _e === void 0 ? true : _e, _f = _a.type, type = _f === void 0 ? 'text' : _f;
    var _g = useState(valueFromProps), currentValue = _g[0], setCurrentValue = _g[1];
    var _h = useState(), error = _h[0], setError = _h[1];
    var _j = useState(), suggestion = _j[0], setSuggestion = _j[1];
    var _k = useState([]), describedBy = _k[0], setDescribedBy = _k[1];
    var inputRef = useRef(null);
    useEffect(function () {
        if (currentValue || (!required && currentValue === '')) {
            var result_1 = validate(currentValue);
            setError(result_1.error);
            setSuggestion(result_1.suggestion);
            setDescribedBy(function () {
                var ids = [];
                result_1.error && ids.push("".concat(id, "Error"));
                result_1.suggestion && ids.push("".concat(id, "Hint"));
                return ids;
            });
        }
    }, [currentValue]);
    useEffect(function () {
        if (valueFromProps) {
            setCurrentValue(valueFromProps);
        }
    }, [valueFromProps]);
    return (_jsxs("div", __assign({ className: "w-full flex flex-col justify-start gap-1 items-start" }, { children: [_jsx("div", __assign({ className: "flex justify-start items-end w-full" }, { children: _jsx(DebounceInput, __assign({ "aria-invalid": !!error, "aria-describedby": describedBy && describedBy.join(' '), autoComplete: autoComplete, className: 'w-full flex-1 text-md-med-m bg-transparent md:text-md-med-d border-0 text-center focus:outline-none pb-[2px]', debounceTimeout: debounceTimeout, disabled: disabled, id: id, maxLength: maxLength, minLength: minLength, name: id, onBlur: function (e) {
                        validate(e.target.value);
                    }, onChange: function (e) {
                        var newValue = e.target.value;
                        setCurrentValue(newValue);
                        onInputChange(newValue);
                    } }, (pattern && { pattern: pattern }), { ref: inputRef, required: required, value: currentValue, type: type })) })), _jsx(LineWithRoundedCaps, {}), _jsxs("label", __assign({ htmlFor: id, className: "flex justify-between self-center items-center gap-1 text-sm-reg-m md:text-sm-reg-d" }, { children: [label, required && _jsx(Asterisk, {})] })), (error || suggestion) && (_jsxs("div", __assign({ className: clsx('border-error-red bg-surface-white', 'w-full border-2 rounded-sm2 p-2xs-gutter text-center', className) }, { children: [error && (_jsx("span", __assign({ id: "".concat(id, "Error"), className: "text-sm-reg-m md:text-sm-reg-d text-center self-center" }, { children: error }))), suggestion && (_jsxs("span", __assign({ id: "".concat(id, "Hint"), className: "text-sm-reg-m md:text-sm-reg-d text-center self-center cursor-pointer", onClick: function () {
                            setCurrentValue(suggestion);
                            onInputChange(suggestion);
                        } }, { children: ["Oops! Did you mean ", _jsx("span", __assign({ className: "font-medium" }, { children: suggestion })), "?"] })))] })))] })));
}
export default FormInputRegular;
